import { useWsT } from './i18n/useWsT';
import React from 'react';
import { usePulse } from './usePulse';
import { fmtNum } from '../mobile/format';
import type { WsNavBadgeKind } from './nav';
import './i18n/common';
import './nav.css';

/**
 * The live count next to a nav item («الطلبات» → orders waiting for the workshop; «المالية» → overdue orders, amber;
 * «الفريق» → new low ratings). Renders nothing at 0, while
 * loading, or for anyone who is not a v2 workshop (usePulse returns null), so it is safe to drop anywhere.
 */
const WsNavBadge: React.FC<{ kind?: WsNavBadgeKind; className?: string }> = ({ kind = 'action', className }) => {
  const pulse = usePulse();
  const { t, i18n } = useWsT();
  const n = kind === 'action' ? pulse?.action ?? 0 : kind === 'overdue' ? pulse?.overdue ?? 0 : pulse?.lowRatings ?? 0;
  if (!n) return null;
  const lang = i18n.language || 'ar';
  const label = kind === 'action'
    ? t('common.nav.waitingBadge', { n: fmtNum(n, lang) })
    : t(kind === 'overdue' ? 'common.nav.overdueBadge' : 'common.nav.lowRatingsBadge', { count: n, n: fmtNum(n, lang) });
  const cls = ['ws-nav-badge', kind === 'overdue' ? 'ws-nav-badge--warn' : '', className || ''].filter(Boolean).join(' ');
  return (
    <span className={cls} aria-label={label} title={label}>
      {fmtNum(n > 99 ? 99 : n, i18n.language || 'ar')}{n > 99 ? '+' : ''}
    </span>
  );
};

export default WsNavBadge;
